export const STATE_KEY = "app:state" as const;
export const BRANDS_CACHE_KEY = "app:brands" as const;
